"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDeribitClientTickerToTicker = exports.mapToCorePositions = void 0;
const __1 = require("..");
const pnlCalculations_1 = require("../pnlCalculations");
const mapToCorePositions = (positions) => {
    return positions.map((p) => {
        const { amount, averagePrice } = (0, __1.getPositionUsableValues)(p);
        return {
            amount: amount,
            amountCurrency: amount,
            averagePrice: averagePrice,
            checked: p.checked,
            instrument: p.instrument,
            uuid: p.uuid,
        };
    });
};
exports.mapToCorePositions = mapToCorePositions;
const mapDeribitClientTickerToTicker = (clientTicker) => {
    const underlyingPrice = (0, pnlCalculations_1.isFutureLikeInstrument)(clientTicker.instrument_name)
        ? clientTicker.mark_price
        : clientTicker.underlying_price;
    return {
        indexPrice: clientTicker.index_price,
        instrument: clientTicker.instrument_name,
        markPrice: clientTicker.mark_price,
        underlyingPrice: underlyingPrice,
        volatility: clientTicker.mark_iv,
        best_ask_amount: clientTicker.best_ask_amount,
        best_ask_price: clientTicker.best_ask_price,
        best_bid_amount: clientTicker.best_bid_amount,
        best_bid_price: clientTicker.best_bid_price,
        ask_iv: clientTicker.ask_iv,
        bid_iv: clientTicker.bid_iv,
        max_price: clientTicker.max_price,
        min_price: clientTicker.min_price,
    };
};
exports.mapDeribitClientTickerToTicker = mapDeribitClientTickerToTicker;
